import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, NgIf]
})
export class ValidationErrorComponent implements OnInit {
  @Input() errors: any = {};
  @Input() name = '';

  constructor() {}

  ngOnInit() {}
}
